import { AddressDto } from '../AddressDto';

export class OrganizationDto {
  chamberOfCommerceNumber: string;
  name: string;
  phoneNumber: string;
  email: string;
  identityVerified: boolean;
  address: AddressDto;
}
